import React, { useState, useRef, useEffect, Fragment, useMemo } from "react";
import "./../components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import Cards from "../components/Cards";
import Bar from "../components/Bar";
import MultipleBarCharts from "../components/MultipleBarCharts";
import MultipleLineCharts from "../components/MultipleLineCharts";
import "../components/Report.scss";
import FeatureIcon from "mdi-react/CheckCircleOutlineIcon";
import Icon from "../components/Icon.jsx";
import CryptoJS from "crypto-js";

import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _getFeaturesArr,
  _chunkArray,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  _formatNum,
  _getBuildingPhotos,
  _getServiceLevel,
  _checkBuildingAltAdr,
  _calPercentage,
  _checkFieldForValue,
  _privateKey,
  _slugifyText
} from "../../../../../../shared/helpers/utils";
import { amenitiesList } from "../../../../../../shared/helpers/bp-utils.js";
import { userEditFieldsObj } from "../../../../../../shared/helpers/userEditFields.js";
import {
  generatePeriodNames,
  prepareResForAI,
  filterAIData,
  getCurrentPeriod,
  getPriorPeriod,
  getRangeEnd,
  getRangeStart,
  formatDate,
  validateNestedData,
  formatDateRange,
  percentageChange,
  roundUpToNearest
} from "../../../exportreport/utils";
import CustomTable from "../../components/CustomTable";
import CustomBarChart from "../components/CustomBarChart";
import { height } from "@material-ui/system";
import Amenities from "../components/Amenities";
import { building } from "../../../../../DataExport/components/EmptyExportList/components/EmptyList";
import { formValues } from "redux-form";
import Footer from "./../../reports/components/Footer";
import CircularProgress from "../components/CircularProgress.jsx";
import SubHeader from "../components/SubHeader.jsx";
import CustomLineChart from "../components/CustomLineChart.jsx";
import CustomSkeleton from "../components/Skeleton.jsx";
import { calculateAverages, getDerived, formatPropertyData, openAIModel, parseEditedHTML } from "../../../exportreport/utils";
import PropertyCard from "./../components/PropertyCard"; // removed
import CoverPage from "./../../reports/components/CoverPage";

const apiURL = process.env.API_ROOT;

let statTypes = [
  {
    key: "residential_sales",
    title: "Condo, Co-op and Single-Family Homes",
    name: "Market Overview",
    checkedColor: "#D5E1A3",
    activitesQuery: "event_tags:(condo* co?op* coop* condo*p single?family)",
    default: true
  },
  {
    key: "condo",
    title: "New and Resale Condos",
    name: "Condo",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(condo* !condo*p) AND -address_2_normalized:"")',
    default: true
  },
  {
    key: "coop",
    title: "New and Resale Co-ops",
    name: "Co-op",
    checkedColor: "#28C2FF",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"")',
    default: true
  },
  {
    key: "single_family",
    title: "Townhouses and Detached Single-Family Homes",
    name: "Single-Family",
    checkedColor: "#FFD23F",
    activitesQuery: "(event_tags:(single?family))"
  }
];

let MIN_COUNT = 10;

const generateShareLink = property => {
  if (!property || !property.building || !property.key) return false;
  var building_slug = property.building.substr(4);
  var shareBaseURL = "https://share.marketproof.com/building/";
  var encryptedBuildingSlug = btoa(
    CryptoJS.AES.encrypt(building_slug, _privateKey)
  );
  var shareLink = building_slug;
  if (property && property.address_2_normalized) {
    shareBaseURL = "https://share.marketproof.com/unit/";
    shareLink =
      building_slug + "/" + _slugifyText(property.address_2_normalized);
  }
  shareLink = btoa(CryptoJS.AES.encrypt(shareLink, _privateKey));
  return shareBaseURL + shareLink;
};

const BlendedLayout = props => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    theme,
    compSettings,
    setAiResponse,
    AiResponse,
    setFetchAi,
    fetchAi,
    setAIInProgress,
    editedContent = ""
  } = props;

  const editedMap = useMemo(() => parseEditedHTML(editedContent), [editedContent]);

  function renderEditedOrDefault(id, fallback) {
    // When comps changed with "Update Suggested Price", all comp-derived
    // values are stale — always use fresh computed values.
    if (reportData && reportData.updateSuggestedPrice) {
      return fallback;
    }
    if (!editedMap || !editedMap[id]) return fallback;
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(editedMap[id], "text/html");
      var el = doc.body.firstElementChild;

      if (el && el.getAttribute("data-changed") === "true") {
        var tag = el.tagName.toLowerCase();
        var props = toReactProps(el);
        props.dangerouslySetInnerHTML = { __html: el.innerHTML };
        return React.createElement(tag, props);
      }
    } catch (e) {
      console.warn("Failed to parse edited HTML for id:", id, e);
    }
    return fallback;
  }

  function toReactProps(el) {
    var props = {};
    for (var i = 0; i < el.attributes.length; i++) {
      var attr = el.attributes[i];
      var name = attr.name;
      var value = attr.value;

      if (name === "class") name = "className";
      else if (name === "for") name = "htmlFor";
      else if (name === "style") {
        props.style = cssTextToObject(value);
        continue;
      }
      props[name] = value;
    }
    return props;
  }

  function cssTextToObject(cssText) {
    var style = {};
    if (!cssText) return style;
    var parts = cssText.split(";");
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i];
      var idx = pair.indexOf(":");
      if (idx === -1) continue;
      var key = pair.slice(0, idx).trim().replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
      var val = pair.slice(idx + 1).trim();
      if (key) style[key] = val;
    }
    return style;
  }

  const { dateOptions } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions);
  const priorPeriod = getPriorPeriod(dateOptions);
  const priorYearPeriod = priorPeriod;
  const rangeEnd = getRangeEnd(dateOptions);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;

  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      const fetchData = async () => {
        await loadData();
      };
      fetchData();
      setSubmit(false);
    }
  }, [submit]);

  useEffect(() => {
    // debug only
    // console.log(reportData, fetchAi)
  }, [reportData, fetchAi]);

  useEffect(() => {
    const fetchAIData = async () => {
      setFetchAi && setFetchAi(false);
      setAIInProgress(true);
      const aiResponse = await handleAIGenerate(reportData);
      setAiResponse && setAiResponse(aiResponse);
      setAIInProgress(false);
    };
    if (reportData && fetchAi) {
      fetchAIData();
    }
  }, [reportData, fetchAi]);

  const getLastMonthsQuery = (fieldName, months) => {
    const now = Math.floor(Date.now() / 1000);
    const monthsAgo = now - months * 30 * 24 * 60 * 60;
    return fieldName + ":[" + monthsAgo + " TO " + now + "]";
  };

  const loadData = async () => {
    const addressQ = compSettings.selectedBuilding.alternate_addresses.join(
      '" OR "'
    );
    let q =
      'alternate_addresses:("' +
      addressQ +
      '") AND (zip:' +
      compSettings.selectedBuilding.zip +
      ' OR borough:"' +
      compSettings.selectedBuilding.borough.toLowerCase() +
      '")';
    const fq = ["deleted:false"];

    setFetchInProgress(true);

    let axiosData = {
      url: apiURL + "/query/we3-buildings?cache=60",
      method: "post",
      query: {
        q: q,
        wt: "json",
        fl:
          "key,display_full_street_address,name,alternate_addresses,geocode,borough,neighborhood,markets_major,zip,floors,inventory_total,year_built,year_converted,building_service_level,building_access,amenities_health,ownership_type,total_units,building_style,building_status",
        fq: fq,
        rows: 1
      }
    };

    let res = await _axiosCall(axiosData)
      .then(async res => {
        if (res && res.docs && res.docs[0]) {
          let building = res.docs[0];

          if (building.ownership_type && building.ownership_type.toLowerCase().indexOf("co-op") !== -1) {
            building.ownership_type = "coop";
          }
          if (building.ownership_type && building.ownership_type.toLowerCase().indexOf("condop") !== -1) {
            building.ownership_type = "condop";
          }

          const compResponse = await getComps(building);

          let theReportData = { buildingRes: building, compResponse, compSettings };
          const derivedData = getDerived(theReportData);
          theReportData["derivedData"] = derivedData;

          setReportData(theReportData);
        }
        return res;
      })
      .catch(error => {
        console.log("error: " + error);
      })
      .finally(() => {
        setFetchInProgress(false);
        setReportLoaded(true);
        setSubmit(false);
        setFetchAi && setFetchAi(true);
      });
  };

  const handleAIGenerate = async theReportData => {
    const { buildingRes, derivedData, compResponse, compSettings, updateSuggestedPrice } = theReportData;
    const {
      subjectProperty,
      avgDOM,
      avgDiscount,
      activeComps,
      avgActiveComps,
      soldComps,
      avgSoldComps,
      currentCashBuyers,
      currentFinancedBuyers,
      percentCashBuyers,
      percentFinanced,
      activityResponse,
      isCoop
    } = derivedData;
    const { domTrends, discountTrends, ppsfTrends } = compResponse;

    var userSuggestedPrice =
      compSettings.propertyDetails &&
        compSettings.propertyDetails.customPrice &&
        parseInt(compSettings.propertyDetails.customPrice) > 100
        ? parseInt(compSettings.propertyDetails.customPrice)
        : false;

    var buildingNameOrAdr = "";
    if (buildingRes && buildingRes.name) {
      buildingNameOrAdr = _capitalizeText(buildingRes.name);
    } else if (buildingRes && buildingRes.display_full_street_address) {
      buildingNameOrAdr = _capitalizeText(buildingRes.display_full_street_address);
    } else if (buildingRes && buildingRes.full_street_address) {
      buildingNameOrAdr = _capitalizeText(buildingRes.full_street_address);
    }

    var subjectBaselineData = [];
    subjectBaselineData.push("suggested subject price: " + subjectProperty["suggestedPrice"]);
    if (
      compResponse["latestPrice"] &&
      compResponse["latestPrice"]["value"] > 0 &&
      compResponse["latestPrice"]["date"]
    ) {
      subjectBaselineData.push("subject last known price: " + compResponse["latestPrice"]["value"]);
      subjectBaselineData.push("subject last known price date: " + compResponse["latestPrice"]["date"]);
      subjectBaselineData.push("subject last known price type: " + compResponse["latestPrice"]["type"]);
      if (compResponse["priceChange"] && compResponse["priceChange"]["relativeAppreciation"]) {
        subjectBaselineData.push(
          "appreciation of similar property since subject's last known price: " +
          compResponse["priceChange"]["relativeAppreciation"]
        );
      }
    }

    var subjectCompData = [];
    if (avgActiveComps && avgActiveComps["avgPPSF"]) {
      subjectCompData.push("on the market comps avg ppsf: " + avgActiveComps["avgPPSF"]);
      subjectCompData.push("on the market comps avg price: " + avgActiveComps["avgPrice"]);
    }
    if (avgSoldComps && avgSoldComps["avgPPSF"]) {
      subjectCompData.push("recently sold comps avg ppsf: " + avgSoldComps["avgPPSF"]);
      subjectCompData.push("recently sold comps avg price: " + avgSoldComps["avgPrice"]);
    }

    var domData = [];
    if (avgDOM) {
      domData.push("average days on market last 6 months: " + Math.round(avgDOM));
    }
    if (domTrends && domTrends.length > 1) {
      domData.push("average days on market this ytd: " + Math.round(domTrends[domTrends.length - 1].avg_dom));
      domData.push("average days on market last year: " + Math.round(domTrends[domTrends.length - 2].avg_dom));
    }

    var discountData = [];
    if (avgDiscount) {
      discountData.push("average discount last 6 months: " + avgDiscount + "%");
    }
    if (discountTrends && discountTrends.length > 0) {
      discountData.push(
        "average discount this ytd: " + discountTrends[discountTrends.length - 1].avg_discount * -1 + "%"
      );
      discountData.push(
        "average discount last year: " + discountTrends[discountTrends.length - 2].avg_discount * -1 + "%"
      );
    }

    var cashFinanceData = [];
    if (percentCashBuyers) {
      cashFinanceData.push("% cash buyers: " + percentCashBuyers + "%");
    }
    if (percentFinanced && !isCoop) {
      cashFinanceData.push("% down payment: " + percentFinanced + "%");
    }

    var strategyData = [];
    if (subjectProperty["suggestedPriceLow"]) {
      strategyData.push("Low range: " + roundUpToNearest(subjectProperty["suggestedPriceLow"]));
      strategyData.push("High range: " + roundUpToNearest(subjectProperty["suggestedPriceHigh"]));
    }

    var theOnTheMarketComps = []
      .concat([formatPropertyData(subjectProperty, true)])
      .concat(activeComps.map(function (item) { return formatPropertyData(item); }))
      .map(function (property) { return JSON.stringify(property); });

    var theSoldComps = []
      .concat([formatPropertyData(subjectProperty, true)])
      .concat(soldComps.map(function (item) { return formatPropertyData(item); }))
      .map(function (property) { return JSON.stringify(property); });

    var prompt;
    if (userSuggestedPrice) {
      prompt =
        "Write a price_overview (Store in JSON Response: price_overview) around 70 words that tells the reader how price was derived using expert input based on the property's condition, size, amenities and market trends in " +
        _capitalizeText(buildingRes.neighborhood) +
        ", then finding similar properties as comps. Do not mention the actual suggested price. Use the following data elements as appropriate. \n" +
        subjectBaselineData.join("\n") +
        "\n\n";
      prompt +=
        "Write a comp_overview (Store in JSON Response: comp_overview) around 70 words that tells the reader how the subject property's suggested price was refined by using similar properties in " +
        _capitalizeText(buildingRes.neighborhood) +
        " currently on the market and recently sold. Tell them we look at relative valuation of each comp to derive a price. Use the following data elements as appropriate. \n" +
        subjectCompData.join("\n") +
        "\n\n";
    } else if (updateSuggestedPrice) {
      prompt =
        "Write a price_overview (Store in JSON Response: price_overview) around 70 words that tells the reader how the subject property's suggested price was derived using the average prices of comparable properties. Do not mention the actual suggested price. Use the following data elements as appropriate. \n" +
        theOnTheMarketComps.join("\n") +
        "\n" +
        theSoldComps.join("\n") +
        "\n\n";
      prompt +=
        "Write a comp_overview (Store in JSON Response: comp_overview) around 70 words that tells the reader how the subject property's suggested price was refined by using similar properties in " +
        _capitalizeText(buildingRes.neighborhood) +
        " currently on the market and recently sold. Tell them we look at relative valuation of each comp to derive a price. Use the following data elements as appropriate. \n" +
        subjectCompData.join("\n") +
        "\n\n";
    } else if (compResponse && compResponse["latestPrice"] && compResponse["latestPrice"]["value"] > 0) {

      if (compResponse && compResponse["priceChange"] && compResponse["priceChange"]["buildingPriceUsed"]) {
        prompt =
          "Write a price_overview (Store in JSON Response: price_overview) around 70 words that tells the reader how the subject property's suggested price was derived using its historical price (sale or last listed on the market based on subject last known price type) and how units have appreciated (or decpreciation) within the building (" + buildingNameOrAdr + ") since the subject property's last known price date. Do not mention the actual suggested price. If last known is a listed price, don't be so absolute about that's value of the property but just using it as a signal\n\n Use the following data elements as appropriate. \n" +
          subjectBaselineData.join("\n") +
          "\n\n";
      } else {
        prompt =
          "Write a price_overview (Store in JSON Response: price_overview) around 70 words that tells the reader how the subject property's suggested price was derived using its historical price (sale or last listed on the market based on subject last known price type) and total market appreciation (or decpreciation) of similar properties since the subject property's last known price date in " +
          _capitalizeText(buildingRes.neighborhood) +
          ", then finding similar properties as comps. Do not mention the actual suggested price. If last known is a listed price, don't be so absolute about that's value of the property but just using it as a singal. Use the following data elements as appropriate. \n" +
          subjectBaselineData.join("\n") +
          "\n\n";
      }

      prompt +=
        "Write a comp_overview (Store in JSON Response: comp_overview) around 70 words that tells the reader how the subject property's suggested price was refined by using similar properties in " +
        _capitalizeText(buildingRes.neighborhood) +
        " currently on the market and recently sold. Tell them we look at relative valuation of each comp to derive a price. Use the following data elements as appropriate. \n" +
        subjectCompData.join("\n") +
        "\n\n";
    } else {
      prompt =
        "Write a price_overview (Store in JSON Response: price_overview) around 70 words that tells the reader how the subject property's suggested price was derived using pricing of similar properties in " +
        _capitalizeText(buildingRes.neighborhood) +
        ". Do not mention the actual suggested price. By using a combination of comparable properties on the market and those recently sold. \n" +
        subjectBaselineData.join("\n") +
        "\n\n";
      prompt +=
        "Write a comp_overview (Store in JSON Response: comp_overview) around 70 words that tells the the subject property's price is refined by comparing qualities of each property. Use the following data elements as appropriate. \n" +
        subjectCompData.join("\n") +
        "\n\n";
    }

    prompt +=
      "Write a days_on_market (Store in JSON Response: days_on_market) around 25 words for a days on market analysis for similar properties in " +
      _capitalizeText(buildingRes.neighborhood) +
      ", focus on last 6 months but also give brief analysis of this year vs. last year. Use the following data elements as appropriate. \n" +
      domData.join("\n") +
      "\n\n";

    prompt +=
      "Write a discount (Store in JSON Response: discount) around 25 words for a discount analysis (sold vs listed price) for similar nearby properties, focus on last 6 months but also give brief analysis of this year vs. last year. Use the following data elements as appropriate. \n" +
      discountData.join("\n") +
      "\n\n";

    if (isCoop) {
      prompt +=
        "Write an analysis for % cash buyers of similar properties to the subject property (Store in JSON Response: cash_finance) around 60 words. Use the following data elements as appropriate. \n" +
        cashFinanceData.join("\n") +
        "\n\n";
    } else {
      prompt +=
        "Write an analysis for % cash buyers and avg % down payment of similar properties to the subject property (Store in JSON Response: cash_finance) around 60 words. Use the following data elements as appropriate. \n" +
        cashFinanceData.join("\n") +
        "\n\n";
    }

    prompt +=
      "Write an summary for subject property pricing strategy options (Store in JSON Response: pricing_strategy) around 100 words. Corrleate range of suggested price to current discount and days on market. Use the following data elements as appropriate. \n" +
      strategyData.join("\n") +
      "\n" +
      domData.join("\n") +
      "\n" +
      discountData.join("\n") +
      "\n\n";

    if (theOnTheMarketComps.length > 1) {
      prompt +=
        "Write a narrative for on the market comps (Store in JSON Response: active_comps) around 80 words. Compare the comps to the subject property denoted, justify for why a comp is more or less expensive than the the suggested price for subject property of " +
        subjectProperty["suggestedPrice"] +
        " focus on size, location, floor, amenities, quality of unit and age. Use the following data elements as appropriate. \n" +
        theOnTheMarketComps.join("\n") +
        "\n\n";
    } else {
      prompt +=
        "Write a narrative for on the market comps (Store in JSON Response: active_comps) around 80 words. Noting that no comparables are curently on the market given the uniquness of the subject property. Explain that further evvaluation of the subject and pricing is required to establish an accurate price. Use the following data elements as appropriate. \n" +
        theOnTheMarketComps.join("\n") +
        "\n\n";
    }

    if (theSoldComps.length > 1) {
      prompt +=
        "Write an summary for recently sold comps (Store in JSON Response: sold_comps) around 80 words. Compare the comps to the subject property denoted, justify for why a comp is more or less expensive than the the suggested price for subject property of " +
        subjectProperty["suggestedPrice"] +
        " focus on size, location, floor, amenities, quality of unit and age. Use the following data elements as appropriate. \n" +
        theSoldComps.join("\n") +
        "\n\n";
    } else {
      prompt +=
        "Write a narrative for on the market comps (Store in JSON Response: active_comps) around 80 words. Noting that no comparables are have sold recently given the uniquness of the subject property. Explain that further evvaluation of the subject and pricing is required to establish an accurate price. Use the following data elements as appropriate. \n" +
        theSoldComps.join("\n") +
        "\n\n";
    }

    var supplyDemandData = (derivedData.activityResponse || []).map(function (item) {
      return JSON.stringify({
        year: item.val.slice(0, 4),
        new_listings: item.new_listings && item.new_listings.count ? Math.round(item.new_listings.count) : 0,
        contracts_signed: item.contract_signed && item.contract_signed.count ? Math.round(item.contract_signed.count) : 0
      });
    });

    prompt +=
      "Write an summary to explain the supply and demand trend (Store in JSON Response: supply_demand_1 and supply_demand_2) around 80 words combined. Supply is new " +
      _capitalizeText(buildingRes.ownership_type) +
      " listings of similar properties in " +
      _capitalizeText(buildingRes.neighborhood) +
      " and demand are contracts signed. Split into two paragraph (supply_demand_1 and supply_demand_2), first should explain what is supply and demand and second analyze the trends in the data. correlate likely external factors that may drive supply and demend, e.g. covid, mortgage rates, financial factors during the period. Use the following data elements as appropriate. DO NOT USE MORE THAN 80 WORDS \n" +
      supplyDemandData.join("\n") +
      "\n\n";

    var thePriceTrendData = (ppsfTrends || []).map(function (item) {
      return JSON.stringify({ year: item.val.slice(0, 4), ppsf: Math.round(item.med_ppsf) });
    });

    prompt +=
      "Write an summary to explain the price trend (Store in JSON Response: price_trend) around 90 words. Price trend refers to PPSF of similar properties in " +
      _capitalizeText(buildingRes.neighborhood) +
      ". Correlate likely external factors that may drive supply and demend, e.g. covid, mortgage rates, financial factors during the period. Use the following data elements as appropriate. \n" +
      thePriceTrendData.join("\n") +
      "\n\n";

    var theDOMTrendData = (domTrends || []).map(function (item) {
      return JSON.stringify({ date: item.val.slice(0, 4), dom: Math.round(item.avg_dom) });
    });

    prompt +=
      "Write an summary to explain the days on market trend (Store in JSON Response: dom_trend) around 60 words. DOM trend refers to days on market of similar properties in " +
      _capitalizeText(buildingRes.neighborhood) +
      ". Use the following data elements as appropriate. \n" +
      theDOMTrendData.join("\n") +
      "\n" +
      domData.join("\n") +
      "\n\n";

    var theDiscountTrendData = (discountTrends || []).map(function (item) {
      return JSON.stringify({ date: item.val.slice(0, 4), discount: item.avg_discount * -1 });
    });

    prompt +=
      "Write an summary to explain the discount trend (Store in JSON Response: discount_trend) around 60 words. Discount trend refers to sold price vs listed price of similar properties in " +
      _capitalizeText(buildingRes.neighborhood) +
      ". If there's a negative discount, it means propertie traded at or above asking price, say that. Use the following data elements as appropriate. \n" +
      theDiscountTrendData.join("\n") +
      "\n" +
      discountData.join("\n") +
      "\n\n";

    var systemContent =
      "You are a real estate agent helping a seller make sense of the value of the subject property, the results will be used as narrative for a comp report. Abbreviate long currency so it's $1.5M, round if less than $1M. If less than $1M use K. No deimcals for prices. Number should be in format ###,###,###. tone in a professional but friendly tone, use simple terms.";

    prompt +=
      'The results should be in valid raw JSON format, no formatting. { "price_overview" : "text", comp_overview: "text", "days_on_market": "text", "discount": "text", "cash_finance" : "text", "pricing_strategy": "text", "active_comps" : "text", "sold_comps" : "text", , "supply_demand_1" : "text", "supply_demand_2" : "text", "price_trend" : "text", "dom_trend" : "text", "discount_trend" : "text" }';

    const queryData = {
      messages: [
        { role: "system", content: systemContent },
        { role: "user", content: prompt }
      ],
      model: "gpt-4.1-mini",
      response_format: { type: "json_object" }
    };

    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData
    };

    var aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      if (res && res.choices && res.choices[0] && res.choices[0].message && res.choices[0].message.content) {
        const result = res.choices[0].message.content;
        try {
          aiResponse = JSON.parse(result);
        } catch (e) { }
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };

  const getComps = async building => {
    const fq = ["deleted:false"];
    var defaultSubFilters = {};
    var isHouse = _isHouse(building);
    var propertyDetails = compSettings.propertyDetails;
    var property = compSettings.propertyDetails.property ? compSettings.propertyDetails.property : null;

    var userSuggestedPrice =
      compSettings.propertyDetails &&
        compSettings.propertyDetails.customPrice &&
        parseInt(compSettings.propertyDetails.customPrice) > 100
        ? parseInt(compSettings.propertyDetails.customPrice)
        : false;

    property = Object.assign(property, propertyDetails);

    var bedroomQuery =
      propertyDetails.bedrooms !== "" &&
        parseInt(propertyDetails.bedrooms) > -1 &&
        !isHouse
        ? "bedrooms:" + (propertyDetails.bedrooms == 0 ? "(0 1)" : propertyDetails.bedrooms)
        : "";

    if (userSuggestedPrice && bedroomQuery) {
      bedroomQuery = " OR " + bedroomQuery + "^5.0";
    }

    var bathsQuery =
      propertyDetails.baths > 0 ? "baths:" + propertyDetails.baths + "^3.0" : "";

    var sqFtQuery = _shouldShow(propertyDetails.sq_ft)
      ? " OR sq_ft:[" +
      Math.round(propertyDetails.sq_ft * 0.8) +
      " TO " +
      Math.round(propertyDetails.sq_ft * 1.2) +
      "]^3.0"
      : "";

    var buildingKeyQuery = _shouldShow(building.key) ? " OR building:" + building.key + "^5.0" : "";

    var neighborhoodQuery = _shouldShow(building.neighborhood)
      ? building.neighborhood.length > 1
        ? ' OR neighborhood:("' + building.neighborhood.join('" "') + '")^1.7'
        : ' OR neighborhood:"' + building.neighborhood + '"^1.7'
      : false;

    var boroughQuery = _shouldShow(building.borough) ? 'borough:"' + building.borough + '"' : false;

    var floorQuery =
      property && _shouldShow(property.floor) && property.floor > 0
        ? " OR floor:[" + parseInt(property.floor * 0.7) + " TO " + parseInt(property.floor * 1.3) + "]^2.5"
        : false;

    var buildingYearQuery = _shouldShow(building.year_built)
      ? " OR year_built:[" + (building.year_built - 10) + " TO " + (building.year_built + 15) + "]^1"
      : "";

    var unitField = "inventory_total";
    var totalUnitsPerc = _shouldShow(building[unitField])
      ? building[unitField] >= 20
        ? _calPercentage(
          building[unitField],
          building[unitField] >= 300 ? 70 : building[unitField] >= 100 ? 30 : building[unitField] >= 40 ? 15 : 5
        )
        : 10
      : undefined;

    var lowEnd = Math.round(building[unitField] - totalUnitsPerc);
    var highEnd = Math.round(building[unitField] + totalUnitsPerc);
    var buildingUnitQuery =
      totalUnitsPerc
        ? " OR total_units:[" + (lowEnd < 0 ? 0 : lowEnd) + " TO " + highEnd + "]^4.5"
        : "";

    var amenitiesToQueryForArr = [
      { val: "doorman", field: "building_service_level", query: "*doorman*" },
      { val: "elevator", field: "building_access", query: "*elevator" },
      {
        val: ["gym", "fitness-room", "fitness room", "fitness_room", "fitness-center", "fitness_center", "fitness center", "health club", "health-club", "health_club"],
        field: "amenities_health",
        query: "(gym fitness?room fitness?center health?club fitness?facilit*)"
      }
    ];

    var amenitiesQueryValues = amenitiesToQueryForArr.reduce(function (acc, current) {
      if (_checkFieldForValue(building, current.field, current.val)) {
        acc.push(Array.isArray(current.val) ? current.val[0] : current.val);
      }
      return acc;
    }, []);

    var amenitiesQuery = [];
    if (amenitiesQueryValues.length > 0) {
      for (var i = 0; i < amenitiesQueryValues.length; i++) {
        var amenitiesVal = amenitiesQueryValues[i];
        // const amenitiesObj = amenitiesToQueryForArr.find(el => el.val.indexOf(amenitiesVal) > -1);
        amenitiesQuery.push("(building_features:" + "(gym fitness?room fitness?center health?club fitness?facilit*)" + ")^1");
      }
    }
    var amentitiesStr = amenitiesQuery.join(" OR ");
    var amenitiesQ = amentitiesStr ? " OR " + amentitiesStr : "";

    var removeSubject = _shouldShow(property.key) ? "-key:" + property.key : null;

    var ownershipType = building.ownership_type.split("-")[0];
    if (building.ownership_type && building.ownership_type.indexOf("condo") >= 0) {
      ownershipType = "condo";
    }
    var ownershipTypeQuery = _shouldShow(building.ownership_type) ? "ownership_type:" + ownershipType : null;
    if (isHouse) {
      ownershipTypeQuery = "ownership_type:*family*";
    }

    function getLatestPrice(data) {
      var obj = Object.assign({}, data);
      var last_listed_sale_price_all = obj.last_listed_sale_price_all;
      var last_listed_sale_date_all = obj.last_listed_sale_date_all;
      var last_sold_price = obj.last_sold_price;
      var last_sold_date = obj.last_sold_date;
      var property_status = obj.property_status;
      var offering_submitted_date = obj.offering_submitted_date;
      var offering_reviewed_date = obj.offering_reviewed_date;
      var offering_accepted_date = obj.offering_accepted_date;
      var offering_effective_date = obj.offering_effective_date;
      var last_listed_sale_modified_date_all = obj.last_listed_sale_modified_date_all;

      // if (last_listed_sale_modified_date_all > last_listed_sale_date_all) {
      //   last_listed_sale_date_all = last_listed_sale_modified_date_all;
      // }
      var effectiveLastListedDate =
        last_listed_sale_date_all && last_listed_sale_date_all > 0
          ? new Date(last_listed_sale_date_all * 1000).toISOString()
          : null;

      if ((!last_listed_sale_date_all || last_listed_sale_date_all <= 0) && property_status === "sponsor") {
        var offeringDates = [offering_submitted_date, offering_reviewed_date, offering_accepted_date, offering_effective_date].filter(function (d) {
          return d && !isNaN(new Date(d).getTime());
        });
        if (offeringDates.length > 0) {
          effectiveLastListedDate = offeringDates.reduce(function (latest, current) {
            return new Date(current) > new Date(latest) ? current : latest;
          });
        }
      }

      var formattedLastSoldDate =
        last_sold_date && last_sold_date > 0 ? new Date(last_sold_date * 1000).toISOString() : null;

      var priceTypes = [
        { type: "listed_sale_price", value: last_listed_sale_price_all, date: effectiveLastListedDate },
        { type: "sold_price", value: last_sold_price, date: formattedLastSoldDate }
      ];

      var validPriceTypes = priceTypes.filter(function (item) {
        return item.value !== null && item.value !== -1 && item.date && !isNaN(new Date(item.date).getTime());
      });

      var latestPriceType = validPriceTypes.reduce(function (latest, current) {
        return new Date(current.date) > new Date(latest.date) ? current : latest;
      }, { date: new Date(0).toISOString() });

      return latestPriceType.date > new Date(0).toISOString() ? Object.assign({}, latestPriceType) : null;
    }

    function calculateRelativeAppreciation(initialDate, priceTrends) {
      if (!priceTrends || priceTrends.length <= 0 || !priceTrends.filter(function (trend) { return trend.med_ppsf > 0; })) return null;
      var initialTimestamp = new Date(initialDate).getTime();
      var initialTrend = priceTrends.reduce(function (closest, current) {
        var currentTimestamp = new Date(current.val).getTime();
        var closestTimestamp = new Date(closest.val).getTime();
        if (!current.med_ppsf || current.count === 0) return closest;
        return Math.abs(currentTimestamp - initialTimestamp) < Math.abs(closestTimestamp - initialTimestamp) ? current : closest;
      });
      if (!initialTrend || !initialTrend.med_ppsf) {
        return { error: "No valid initial trend data found for the given date" };
      }
      var latestTrend = priceTrends.slice(0).reverse().find(function (trend) { return trend.count >= MIN_COUNT; });
      if (!latestTrend) {
        return { error: "No valid trend data with a nonzero avg_ppsf found" };
      }
      var initialPPSF = initialTrend.med_ppsf;
      var latestPPSF = latestTrend.med_ppsf;
      console.log("trendCalc", initialTrend, latestTrend)
      var relativeAppreciation = (latestPPSF - initialPPSF) / initialPPSF;

      var buildingPriceUsed = priceTrends[0]['buildingPrice'] ? priceTrends[0]['buildingPrice'] : false;
      return { initialDate: initialTrend.val, initialPPSF: initialPPSF, latestDate: latestTrend.val, latestPPSF: latestPPSF, relativeAppreciation: relativeAppreciation, buildingPriceUsed };
    }

    function getAverageCount(priceTrends) {
      if (!priceTrends || !priceTrends.length) return 0;
      var total = priceTrends.reduce(function (sum, item) { return sum + (item.count || 0); }, 0);
      return total / priceTrends.length;
    }

    var latestPrice = property ? getLatestPrice(property) : false;
    if (!latestPrice) {
      latestPrice = { date: "2015-01-01T05:00:00Z", value: 0 };
    }

    var priceTrends, domTrends, currentDOM, discountTrends, currentDiscount, ppsfTrends, currentCashBuyers, currentFinancedBuyers, priceChange;
    var expectedCurrentPrice = latestPrice ? latestPrice.value : false;
    var activityResponse = await getActivities(building);

    var trendResponse = await getPriceTrends(building, latestPrice);
    priceTrends = trendResponse && trendResponse.price_trend ? trendResponse.price_trend : null;
    MIN_COUNT = getAverageCount(priceTrends) * 0.25;
    domTrends = trendResponse.dom_trend ? trendResponse.dom_trend.filter(function (item) { return item.count >= MIN_COUNT; }) : null;
    currentDOM = trendResponse.current_dom ? trendResponse.current_dom : null;
    discountTrends = trendResponse.discount_trend ? trendResponse.discount_trend.filter(function (item) { return item.count >= MIN_COUNT; }) : null;
    ppsfTrends = trendResponse.ppsf_trend ? trendResponse.ppsf_trend.filter(function (item) { return item.count >= MIN_COUNT; }) : null;
    currentDiscount = trendResponse.current_discount ? trendResponse.current_discount : null;
    currentCashBuyers = trendResponse.current_cash_buyers ? trendResponse.current_cash_buyers : null;
    currentFinancedBuyers = trendResponse.current_financed_buyers ? trendResponse.current_financed_buyers : null;

    if (priceTrends && priceTrends.length > 0) {
      console.log(latestPrice, priceTrends);
      priceChange = calculateRelativeAppreciation(latestPrice.date, priceTrends);
      if (priceChange && priceChange.relativeAppreciation) {
        expectedCurrentPrice = (1 + priceChange.relativeAppreciation) * latestPrice.value;
      }
    }

    var priceThreshold = 10000000;
    var maxPrice = 100000000;
    var baseLow = 0.6, baseHigh = 1.5;
    var baseActive = 6, baseSold = 24;
    var maxLow = 0.3, maxHigh = 3.0;
    var maxActive = 48, maxSold = 120;

    var multiplierLow = baseLow;
    var multiplierHigh = baseHigh;
    var activeMonthRange = baseActive;
    var soldMonthRange = baseSold;

    if (expectedCurrentPrice && expectedCurrentPrice > priceThreshold) {
      var baseFactor = (expectedCurrentPrice - priceThreshold) / (maxPrice - priceThreshold);
      var factor = Math.min(Math.sqrt(baseFactor), 1);
      multiplierLow = baseLow - factor * (baseLow - maxLow);
      multiplierHigh = baseHigh + factor * (maxHigh - baseHigh);
      activeMonthRange = Math.round(baseActive + factor * (maxActive - baseActive));
      soldMonthRange = Math.round(baseSold + factor * (maxSold - baseSold));
    }

    var priceFloorQuery = expectedCurrentPrice
      ? "[" + Math.round(expectedCurrentPrice * multiplierLow) + " TO " + Math.round(expectedCurrentPrice * multiplierHigh) + "]"
      : "[" + (latestPrice && latestPrice.value > 0 ? latestPrice.value : "100000") + " TO *]";

    if (userSuggestedPrice) {
      priceFloorQuery = "[" + Math.round(userSuggestedPrice * 0.75) + " TO " + Math.round(userSuggestedPrice * 1.25) + "]";
    }

    var activeDateQuery =
      "current_status:(active) AND last_listed_sale_price_all:" +
      priceFloorQuery +
      " AND " +
      getLastMonthsQuery("last_listed_sale_date_all", activeMonthRange);

    var soldDateQuery =
      "current_status:(sold) AND last_sold_price:" +
      priceFloorQuery +
      " AND " +
      getLastMonthsQuery("last_sold_date", soldMonthRange);

    var compMatchQuery =
      bathsQuery +
      sqFtQuery +
      floorQuery +
      buildingYearQuery +
      buildingUnitQuery +
      (neighborhoodQuery ? neighborhoodQuery : "") +
      buildingKeyQuery +
      amenitiesQ +
      (userSuggestedPrice ? bedroomQuery : "");

    var compQuery = {
      q: compMatchQuery,
      fq: [
        removeSubject,
        boroughQuery,
        "deleted:false",
        //_shouldShow(propertyDetails.sq_ft) ? "sq_ft:[300 TO *]" : null,
        "{!geofilt}",
        isHouse ? "" : '-address_2_normalized:""',
        !userSuggestedPrice ? bedroomQuery : "",
        ownershipTypeQuery
      ],
      fl: [
        "full_street_address",
        "display_full_street_address",
        "zip",
        "address_2",
        "address_2_normalized",
        "floor",
        "bedrooms",
        "baths",
        "half_baths",
        "current_status",
        "sq_ft",
        "exterior_sq_ft",
        "offering_price",
        "building",
        "building_name",
        "neighborhood",
        "borough",
        "monthly_fees",
        "monthly_taxes",
        "key",
        "total_units",
        "residential_units",
        "last_sold_price",
        "last_sold_date",
        "price",
        "last_listed_sale_price_all",
        "last_listed_sale_date_all",
        "last_listed_sale_modified_date_all",
        "last_listed_sale_ppsf_all",
        "last_listed_rent_price_all",
        "last_listed_rent_date_all",
        "last_contract_date",
        "last_contract_price",
        "last_contract_date_formatted",
        "last_listed_sale_key_all",
        "last_listed_rent_key_all",
        "last_listed_sale_status_all",
        "last_listed_rent_status_all",
        "id",
        "div(last_sold_price, sq_ft)",
        "div(last_listed_sale_price_all, sq_ft)",
        "div(last_contract_price, sq_ft)",
        "div(sub(offering_price, last_listed_sale_price_all), offering_price)",
        "div(sub(offering_price, last_sold_price), offering_price)",
        "owner",
        "ownership_type",
        "borough_code",
        "block",
        "lot",
        "year*",
        "building_class",
        "property_features",
        "building_features",
        "score",
        "geodist()"
      ],
      wt: "json",
      sfield: "geocode",
      pt: building.geocode,
      d: 2,
      sort: "score desc, geodist() asc",
      start: 0,
      rows: 8,
      group: true,
      "group.limit": 20,
      "group.query": [activeDateQuery, soldDateQuery]
    };

    setFetchInProgress(true);
    var axiosData = { url: apiURL + "/query/we3-properties?cache=60", method: "post", query: compQuery };
    var res = await _axiosCall(axiosData);

    var activeComps = res[activeDateQuery] && res[activeDateQuery].doclist && res[activeDateQuery].doclist.docs ? res[activeDateQuery].doclist.docs : [];
    var soldComps = res[soldDateQuery] && res[soldDateQuery].doclist && res[soldDateQuery].doclist.docs ? res[soldDateQuery].doclist.docs : [];

    var activePPSF = activeComps.map(function (item) { return item["div(last_listed_sale_price_all, sq_ft)"]; });
    var soldPPSF = soldComps.map(function (item) { return item["div(last_sold_price, sq_ft)"]; });
    var sum = activePPSF.concat(soldPPSF).reduce(function (total, value) { return total + value; }, 0);
    var avgPPSF = sum / activePPSF.concat(soldPPSF).length;

    var suggestedPrice = userSuggestedPrice ? userSuggestedPrice : expectedCurrentPrice ? expectedCurrentPrice : Math.round(avgPPSF * property.sq_ft);

    // console.log(avgPPSF, property.sqft, suggestedPrice);
    if (!suggestedPrice || suggestedPrice < 1000) {
      var allPrices = activeComps.map(function (c) { return c.last_listed_sale_price_all; }).concat(soldComps.map(function (c) { return c.last_sold_price; }));
      suggestedPrice = allPrices.reduce(function (total, price) { return total + price; }, 0) / allPrices.length;

      // console.log(allPrices);
    }

    var avgDOM = trendResponse.current_dom && trendResponse.current_dom.avg_dom ? trendResponse.current_dom.avg_dom : null;
    var avgDiscount = trendResponse.current_discount && trendResponse.current_discount.avg_discount ? trendResponse.current_discount.avg_discount : null;

    return {
      expectedCurrentPrice: roundUpToNearest(expectedCurrentPrice),
      suggestedPrice: roundUpToNearest(suggestedPrice),
      latestPrice,
      priceChange,
      comps: { active: activeComps, sold: soldComps, priceTrends: priceTrends },
      domTrends: domTrends,
      avgDOM: avgDOM,
      discountTrends: discountTrends,
      avgDiscount: avgDiscount,
      ppsfTrends: ppsfTrends,
      currentCashBuyers,
      currentFinancedBuyers,
      activityResponse
    };
  };

  const getPriceTrends = async (building, latestPrice) => {
    if (!building) return null;
    var q;
    if (building.neighborhood) {
      q =
        '((("neighborhood:"' +
        building.neighborhood[0].toLowerCase() +
        '"" OR markets_major:"' +
        building.markets_major[0] +
        '") AND borough:"' +
        building.borough.toLowerCase() +
        '"))';
    } else if (building.zip) {
      q = "(zip:" + building.zip + ")";
    } else {
      return null;
    }

    var ownershipType = building.ownership_type.split("-")[0];
    if (building.ownership_type && building.ownership_type.indexOf("condo") >= 0) {
      ownershipType = "condo";
    }
    var defaultQ = 'ownership_type:"' + ownershipType + '"';
    var isHouse = _isHouse(building);
    if (isHouse) {
      defaultQ = "ownership_type:*family*";
    }

    var fq = [
      "status:sold",
      "transaction_source:ACRIS*",
      "price:[50000 TO *]",
      "parcels_count:1",
      "{!join from=alternate_keys fromIndex=we3-buildings to=building}" + defaultQ
    ];

    let sponsorQ = ""

    if (building.building_status && ["sponsor", "pipeline"].indexOf(building.building_status) >= 0) {
      sponsorQ = "AND sponsored_sale:true";
    }

    const addressQ = building.alternate_addresses.join(
      '" OR "'
    );
    let buildingQ =
      'alternate_addresses:("' +
      addressQ +
      '")';

    function hasEnoughSample(buckets, minPerYear, recentWithinYears) {
      var min = typeof minPerYear === 'number' ? minPerYear : 3;
      var recentYears = typeof recentWithinYears === 'number' ? recentWithinYears : 2;
      if (!buckets || !buckets.length) return false;

      // Normalize and sort by date.
      var items = [];
      for (var i = 0; i < buckets.length; i++) {
        var b = buckets[i];
        if (!b || !b.val) continue;
        var d = new Date(b.val);
        if (isNaN(d.getTime())) continue;
        var c = typeof b.count === 'number' ? b.count : 0;
        items.push({ date: d, year: d.getUTCFullYear(), count: c });
      }
      if (!items.length) return false;
      items.sort(function (a, b) { return a.date - b.date; });

      // Aggregate counts by year.
      var byYear = {};
      for (var j = 0; j < items.length; j++) {
        var y = items[j].year;
        byYear[y] = (byYear[y] || 0) + items[j].count;
      }

      // Start year must meet min.
      var startYear = items[0].year;
      if ((byYear[startYear] || 0) < min) return false;

      // Recent year logic: last year OR previous item if within N years of today.
      var today = new Date();
      var msPerYear = 365 * 24 * 60 * 60 * 1000;
      var lastItem = items[items.length - 1];
      var recentOk = (byYear[lastItem.year] || 0) >= min;

      if (!recentOk && items.length >= 2) {
        var prevItem = items[items.length - 2];
        var deltaMs = Math.abs(today - prevItem.date);
        var within = deltaMs <= recentYears * msPerYear;
        if (within) {
          recentOk = (byYear[prevItem.year] || 0) >= min;
        }
      }

      return recentOk;
    }


    var axiosData = {
      url: apiURL + "/query/we3-transactions?cache=60",
      method: "post",
      query: {
        q: q,
        fq: fq,
        fl: null,
        rows: 0,
        start: 0,
        wt: "json",
        "json.facet": {
          price_trend: {
            type: "query",
            q: `price_per_sqft:[300 TO 20000]${sponsorQ}`,
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: latestPrice.date,
                  end: "NOW",
                  gap: "+6MONTHS",
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)",
                    avg_price: "avg(price)"
                  }
                }
              }
            }
          },
          price_trend_building: {
            type: "query",
            q: `price_per_sqft:[300 TO 20000] AND ${buildingQ}`,
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: latestPrice.date,
                  end: "NOW",
                  gap: "+12MONTHS",
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)",
                    avg_price: "avg(price)"
                  }
                }
              }
            }
          },
          current_dom: {
            type: "query",
            q: `days_to_contract:[10 TO 600] AND close_date_formatted:[NOW-6MONTHS TO NOW]`,
            facet: { avg_dom: "avg(days_to_contract)" }
          },
          dom_trend: {
            type: "query",
            q: `days_to_contract:[10 TO 600]${sponsorQ}`,
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: "2015-01-01T05:00:00Z",
                  end: "NOW",
                  gap: "+1YEAR",
                  facet: { avg_dom: "avg(days_to_contract)" }
                }
              }
            }
          },
          current_discount: {
            type: "query",
            q: `discount:[-30 TO 30] AND close_date_formatted:[NOW-6MONTHS TO NOW]${sponsorQ}`,
            facet: { avg_discount: "avg(discount)" }
          },
          discount_trend: {
            type: "query",
            q: `discount:[-30 TO 30]${sponsorQ}`,
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: "2015-01-01T05:00:00Z",
                  end: "NOW",
                  gap: "+1YEAR",
                  facet: { avg_discount: "avg(discount)" }
                }
              }
            }
          },
          ppsf_trend: {
            type: "query",
            q: `price_per_sqft:[300 TO 20000]${sponsorQ}`,
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: "2015-01-01T05:00:00Z",
                  end: "NOW",
                  gap: "+1YEAR",
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)"
                  }
                }
              }
            }
          },
          current_cash_buyers: { type: "query", q: "-lender:* AND close_date_formatted:[NOW-6MONTHS TO NOW]" },
          current_financed_buyers: { type: "query", q: "lender:* AND close_date_formatted:[NOW-6MONTHS TO NOW]", facet: { avg_financed: "avg(percent_financed)" } }
        }
      }
    };

    var res = await _axiosCall(axiosData);
    if (res && res.facets && res.facets.price_trend && res.facets.price_trend.by_time && res.facets.price_trend.by_time.buckets) {
      let buildingPriceUsed = false;
      if (res.facets.price_trend_building && res.facets.price_trend_building.by_time
        && res.facets.price_trend_building.by_time.buckets
        && hasEnoughSample(res.facets.price_trend_building.by_time.buckets)) {
        buildingPriceUsed = true;
        res.facets.price_trend_building.by_time.buckets.forEach(item => item["buildingPrice"] = true);
      }
      return {
        price_trend: buildingPriceUsed ? res.facets.price_trend_building.by_time.buckets : res.facets.price_trend.by_time.buckets,
        dom_trend: res.facets.dom_trend.by_time.buckets,
        current_dom: res.facets.current_dom,
        discount_trend: res.facets.discount_trend.by_time.buckets,
        current_discount: res.facets.current_discount,
        ppsf_trend: res.facets.ppsf_trend.by_time.buckets,
        current_cash_buyers: res.facets.current_discount,
        current_financed_buyers: res.facets.current_financed_buyers
      };
    }
    return {};
  };

  const getActivities = async building => {
    if (!building) return null;
    var defaultQ;
    if (building.neighborhood) {
      defaultQ =
        "event_tags:*" +
        building.ownership_type.split("-")[0] +
        "* AND (neighborhood:\"" +
        building.neighborhood[0].toLowerCase() +
        '" AND borough:"' +
        building.borough.toLowerCase() +
        '")';
    } else if (building.zip) {
      defaultQ = "event_tags:*" + building.ownership_type.split("-")[0] + "* AND (zip:" + building.zip + ")";
    } else {
      return null;
    }

    var isHouse = _isHouse(building);
    if (isHouse) {
      defaultQ =
        "event_tags:*family* AND (neighborhood:\"" +
        building.neighborhood[0].toLowerCase() +
        '" AND borough:"' +
        building.borough.toLowerCase() +
        '")';
    }

    setFetchInProgress(true);
    var axiosData = {
      url: apiURL + "/query/we3-activities-3",
      method: "post",
      query: {
        q: defaultQ,
        fq: ["hierarchy:[0 TO 2]", "price:[100000 TO 300000000]"],
        wt: "json",
        rows: 0,
        "json.facet": {
          by_time: {
            range: {
              field: "time",
              start: "2020-01-01T05:00:00Z",
              end: "NOW",
              gap: "+1YEAR",
              facet: {
                contract_signed: { type: "query", q: "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*" },
                new_listings: { type: "query", q: "topic:listings AND event_tags:just-listed AND -event_tags:rent AND -event_tags:*commercial*" }
              }
            }
          }
        }
      }
    };
    var res = await _axiosCall(axiosData);
    if (res && res.facets.by_time && res.facets.by_time.buckets) {
      return res.facets.by_time.buckets;
    } else {
      return null;
    }
  };

  if (!reportData) return null;

  const {
    subjectProperty,
    avgDOM,
    avgDiscount,
    activeComps,
    avgActiveComps,
    soldComps,
    avgSoldComps,
    currentCashBuyers,
    currentFinancedBuyers,
    percentCashBuyers,
    percentFinanced,
    activityResponse,
    isCoop
  } = reportData.derivedData;

  const currentDate = new Date();
  const options = { year: "numeric", month: "long" };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);

  const buildingRes = reportData && reportData.buildingRes ? reportData.buildingRes : {};
  var buildingNameOrAdr = "";
  if (buildingRes && buildingRes.name) {
    buildingNameOrAdr = _capitalizeText(buildingRes.name);
  } else if (buildingRes && buildingRes.display_full_street_address) {
    buildingNameOrAdr = _capitalizeText(buildingRes.display_full_street_address);
  } else if (buildingRes && buildingRes.full_street_address) {
    buildingNameOrAdr = _capitalizeText(buildingRes.full_street_address);
  }

  var compUnitSuffix = "";
  if (
    compSettings &&
    compSettings.propertyDetails &&
    compSettings.propertyDetails.property &&
    compSettings.propertyDetails.property.address_2_normalized
  ) {
    compUnitSuffix =
      " - " +
      compSettings.propertyDetails.property.address_2_normalized.toUpperCase().replace("APT ", "");
  }
  var reportTitle = buildingNameOrAdr + compUnitSuffix;

  // helper to render one card inline (not a subcomponent)


  return (
    <>
      <CoverPage
        {...props}
        summarizeGeographies={summarizeGeographies}
        priorYearPeriodName={priorYearPeriodName}
        currentPeriodName={currentPeriodName}
        dateDisplay={formattedDate}
        defaultImage={subjectProperty && subjectProperty.building ? "https://newsapi.marketproof.com/buildings/pictures/" + subjectProperty.building : false}
      />

      <div className="report-container page-section comp-view building-view-3-page-1">
        <SubHeader
          reportData={reportData}
          reportTitle={reportTitle}
          dateDisplay={formattedDate}
          editedContent={editedContent}
        />

        <section className="report-section">
          <div className="suggested-price-card">
            <Icon />
            <div className="price-details">
              <p id="labelSuggestedPrice" className="label editable track-original">Suggested List Price</p>
              {renderEditedOrDefault(
                "suggestedPrice",
                <h2 id="suggestedPrice" className="price editable track-original">
                  {subjectProperty["suggestedPrice"] ? _formatCurrency(subjectProperty["suggestedPrice"]) : "--"}
                </h2>
              )}
            </div>

            <div className="divider"></div>

            <div className="range-details">
              <p id="labelRange" className="label editable track-original">Range</p>
              {renderEditedOrDefault(
                "priceRange",
                <h3 id="priceRange" className="range editable track-original">
                  {subjectProperty["suggestedPriceLow"]
                    ? _formatPrice(roundUpToNearest(subjectProperty["suggestedPriceLow"])) +
                    "- " +
                    _formatPrice(roundUpToNearest(subjectProperty["suggestedPriceHigh"]))
                    : "--"}
                </h3>
              )}
            </div>
          </div>

          <div className="center-container">
            <div className="left-side">
              {renderEditedOrDefault("howPriceDetermined", <h3 id="howPriceDetermined" className="sub-main-heading">How is the price determined?</h3>)}
              {renderEditedOrDefault("priceOverview", <p id="priceOverview" className="editable track-original">{AiResponse && AiResponse.price_overview ? AiResponse.price_overview : <CustomSkeleton count={8} />}</p>)}
              {renderEditedOrDefault("compOverview", <p id="compOverview" className="editable track-original">{AiResponse && AiResponse.comp_overview ? AiResponse.comp_overview : <CustomSkeleton count={8} />}</p>)}
            </div>

            <div className="right-side">
              <div className="column1">
                <div className="main-title">
                  <span>{_formatNumber(avgDOM)}</span>
                  <span>Days</span>
                </div>
                {renderEditedOrDefault("typicalDOMLabel", <h3 id="typicalDOMLabel" className="editable track-original">typical Days on market</h3>)}
                {renderEditedOrDefault("daysOnMarket", <p id="daysOnMarket" className="editable track-original">{AiResponse && AiResponse.days_on_market ? AiResponse.days_on_market : <CustomSkeleton count={11} />}</p>)}
              </div>

              <div className="column2">
                <div className="main-title">
                  <span>{avgDiscount}%</span>
                </div>
                {renderEditedOrDefault("typicalDiscountLabel", <h3 id="typicalDiscountLabel" className="editable track-original">typical Discount</h3>)}
                {renderEditedOrDefault("discount", <p id="discount" className="editable track-original">{AiResponse && AiResponse.discount ? AiResponse.discount : <CustomSkeleton count={11} />}</p>)}
              </div>
            </div>
          </div>

          <div className="last-cont">
            <div className="circle_container">
              {renderEditedOrDefault("buyersLabel", <h3 id="buyersLabel" className="sub-main-heading">Buyers of similar properties</h3>)}
              <div className="circle_inner_main_wraper">
                <div className="semi-progress-container">
                  <CircularProgress value={percentCashBuyers} />
                  <span id="cashBuyersLabel" className="editable track-original">CASH BUYERS</span>
                </div>
                {!isCoop ? (
                  <div className="semi-progress-container">
                    <CircularProgress value={percentFinanced} />
                    <span id="downPaymentLabel" className="editable track-original">DOWN PAYMENT</span>
                  </div>
                ) : null}
              </div>
              {renderEditedOrDefault("cashFinance", <p id="cashFinance" className="editable track-original">{AiResponse && AiResponse.cash_finance ? AiResponse.cash_finance : <CustomSkeleton count={6} />}</p>)}
            </div>

            <div className="right_side_circle-container">
              {renderEditedOrDefault("pricingStrategyLabel", <h3 id="pricingStrategyLabel" className="editable track-original">Pricing strategy</h3>)}
              {renderEditedOrDefault("pricingStrategy", <p id="pricingStrategy" className="editable track-original">{AiResponse && AiResponse.pricing_strategy ? AiResponse.pricing_strategy : <CustomSkeleton count={12} />}</p>)}
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {/* ACTIVE COMPS */}
      <div className="report-container page-section building-view-3-page-1">
        <SubHeader reportData={reportData} reportTitle={reportTitle} dateDisplay={formattedDate} editedContent={editedContent} />
        <div className="vertical-divider"></div>
        <div className="horizontal-divider"></div>
        <div className="border-divider"></div>

        <section className="report-section">
          {renderEditedOrDefault("activeCompsHeading", <h3 id="activeCompsHeading" className="editable comp-type-heading track-original">Comparable properties on the market</h3>)}

          <div className="property-type-values">
            {renderEditedOrDefault("activeCompsText", <p id="activeCompsText" className="editable track-original">{AiResponse && AiResponse.active_comps ? AiResponse.active_comps : <CustomSkeleton count={8} />}</p>)}

            <div className="property-type-numeric-content">
              <div>
                {renderEditedOrDefault("activeAvgPrice", <div id="activeAvgPrice" className="property-type-price editable track-original">{avgActiveComps && avgActiveComps.avgPrice ? _formatPrice(avgActiveComps.avgPrice) : "--"}</div>)}
                {renderEditedOrDefault("activeAvgPriceLabel", <div id="activeAvgPriceLabel" className="property-asking-price editable track-original">Average Asking Price</div>)}
              </div>
              <div>
                {renderEditedOrDefault("activeAvgPPSF", <div id="activeAvgPPSF" className="property-type-price editable track-original">{avgActiveComps && avgActiveComps.avgPPSF ? "$" + _formatNumber(avgActiveComps.avgPPSF) : "--"}</div>)}
                {renderEditedOrDefault("activeAvgPPSFLabel", <div id="activeAvgPPSFLabel" className="property-asking-price editable track-original">Average Asking PSF</div>)}
              </div>
            </div>
          </div>

          <div className="property-comparison-container">
            {[
              { original: subjectProperty, formatted: formatPropertyData(subjectProperty, true, "active") },
            ]
              .concat(
                activeComps
                  .slice(0)
                  .sort(function (a, b) { return a["geodist()"] - b["geodist()"]; })
                  .map(function (item) { return { original: item, formatted: formatPropertyData(item, false, "active") }; })
              )
              .map(function (pair, index) {
                var original = pair.original;
                var formatted = pair.formatted;
                return (
                  <PropertyCard
                    key={formatted.id}
                    property={formatted}
                    index={index}
                    isSubject={formatted.isSubject}
                    isSelected={false}
                    showSelectIcon={false}
                    compSource="activeComps"
                    showChangeButton={!formatted.isSubject}
                    avgDOM={_formatNumber(avgDOM)}
                    linkURL={generateShareLink(original)}
                    openDetailModal={props && props.openDetailModal ? props.openDetailModal : null}
                    renderEditedOrDefault={renderEditedOrDefault}
                  />
                );
              })}


            {activeComps.length <= 0 ? (
              <div className="prpoerty-no-comps">
                {renderEditedOrDefault("noActiveCompsHeading", <h3 id="noActiveCompsHeading" className="editable comp-type-heading track-original">No Comps Available</h3>)}
                {renderEditedOrDefault("noActiveCompsText", <p id="noActiveCompsText" className="editable track-original">Due to the unique nature of the subject property, there are currently no suitable comparable properties on the market.</p>)}
                <div
                  data-comp-key={false}
                  data-comp-type={"active"}
                  className="no-comp-button property-badge comp-chg print-hide badge-comp open-comps"
                >
                  <span className="comp-tag">Choose Comps</span>
                </div>
              </div>
            ) : null}
          </div>
        </section>

        <Footer />
      </div>

      {/* SOLD COMPS */}
      <div className="report-container page-section building-view-3-page-1">
        <div className="vertical-divider"></div>
        <div className="horizontal-divider"></div>
        <div className="border-divider"></div>

        <SubHeader reportData={reportData} reportTitle={reportTitle} dateDisplay={formattedDate} editedContent={editedContent} />

        <section className="report-section">
          {renderEditedOrDefault("soldCompsHeading", <h3 id="soldCompsHeading" className="editable comp-type-heading track-original">Recently sold comparable properties</h3>)}

          <div className="property-type-values">
            {renderEditedOrDefault("soldCompsText", <p id="soldCompsText" className="editable track-original">{AiResponse && AiResponse.sold_comps ? AiResponse.sold_comps : <CustomSkeleton count={8} />}</p>)}

            <div className="property-type-numeric-content">
              <div>
                {renderEditedOrDefault("soldAvgPrice", <div id="soldAvgPrice" className="property-type-price editable track-original">{avgSoldComps && avgSoldComps.avgPrice ? _formatPrice(avgSoldComps.avgPrice) : "--"}</div>)}
                {renderEditedOrDefault("soldAvgPriceLabel", <div id="soldAvgPriceLabel" className="property-asking-price editable track-original">Average Sold Price</div>)}
              </div>
              <div>
                {renderEditedOrDefault("soldAvgPPSF", <div id="soldAvgPPSF" className="property-type-price editable track-original">{avgSoldComps && avgSoldComps.avgPPSF ? "$" + _formatNumber(avgSoldComps.avgPPSF) : "--"}</div>)}
                {renderEditedOrDefault("soldAvgPPSFLabel", <div id="soldAvgPPSFLabel" className="property-asking-price editable track-original">Average Sold PSF</div>)}
              </div>
            </div>
          </div>

          <div className="property-comparison-container">
            {[
              { original: subjectProperty, formatted: formatPropertyData(subjectProperty, true) }
            ]
              .concat(
                soldComps
                  .slice(0)
                  .sort(function (a, b) { return a["geodist()"] - b["geodist()"]; })
                  .map(function (item) { return { original: item, formatted: formatPropertyData(item, false, "sold") }; })
              )
              .map(function (pair, index) {
                var original = pair.original;
                var formatted = pair.formatted;
                return (
                  <PropertyCard
                    key={formatted.id}
                    property={formatted}
                    index={index}
                    isSubject={formatted.isSubject}
                    isSelected={false}
                    showSelectIcon={false}
                    compSource="soldComps"
                    showChangeButton={!formatted.isSubject}
                    avgDOM={_formatNumber(avgDOM)}
                    linkURL={generateShareLink(original)}
                    openDetailModal={props && props.openDetailModal ? props.openDetailModal : null}
                    renderEditedOrDefault={renderEditedOrDefault}
                  />
                );
              })}


            {soldComps.length <= 0 ? (
              <div className="prpoerty-no-comps">
                {renderEditedOrDefault("noSoldCompsHeading", <h3 id="noSoldCompsHeading" className="editable comp-type-heading track-original">No Comps Available</h3>)}
                {renderEditedOrDefault("noSoldCompsText", <p id="noSoldCompsText" className="editable track-original">Due to the unique nature of the subject property, there are no recent comparable sales available.</p>)}
                <div
                  data-comp-key={false}
                  data-comp-type={"sold"}
                  className="no-comp-button property-badge comp-chg print-hide badge-comp open-comps"
                >
                  <span className="comp-tag">Choose Comps</span>
                </div>
              </div>
            ) : null}
          </div>
        </section>

        <Footer />
      </div>

      {/* Neighborhood Analysis */}
      <div className="report-container page-section building-view-3-page-1 building-view-3-last-page">
        <SubHeader
          reportData={reportData}
          reportTitle={reportTitle}
          dateDisplay={formattedDate}
          editedContent={editedContent}
          subtext="NEIGHBORHOOD ANALYSIS"
        />
        <div className="vertical-divider"></div>
        <div className="horizontal-divider"></div>
        <div className="border-divider"></div>

        <section className="report-section">
          <div>
            {renderEditedOrDefault("supplyDemandHeading", <h3 id="supplyDemandHeading" className="editable track-original">Supply & demand</h3>)}
            <div className="content_wrapper">
              <div className="content">
                {renderEditedOrDefault("supplyDemand1", <p id="supplyDemand1" className="editable track-original">{AiResponse && AiResponse.supply_demand_1 ? AiResponse.supply_demand_1 : <CustomSkeleton count={5} />}</p>)}
                {renderEditedOrDefault("supplyDemand2", <p id="supplyDemand2" className="editable track-original">{AiResponse && AiResponse.supply_demand_2 ? AiResponse.supply_demand_2 : <CustomSkeleton count={6} />}</p>)}
              </div>
              <div className="bar-multichart">
                <MultipleBarCharts
                  data={(activityResponse || []).map(function (item) {
                    return {
                      date: item.val.slice(0, 4),
                      value1: item.new_listings && item.new_listings.count ? Math.round(item.new_listings.count) : 0,
                      value2: item.contract_signed && item.contract_signed.count ? Math.round(item.contract_signed.count) : 0
                    };
                  })}
                  height={300}
                  isWeekly={dateOptions.gap}
                  legendNames={{ value1: "Supply", value2: "Demand" }}
                />
              </div>
            </div>

            {renderEditedOrDefault("priceTrendsHeading", <h3 id="priceTrendsHeading" className="editable track-original">Price Trends</h3>)}

            <div className="center-part">
              <div className="line-chart">
                <CustomLineChart
                  theme={theme}
                  data={(reportData.compResponse.ppsfTrends || []).map(function (item) { return { date: item.val.slice(0, 4), value: Math.round(item.med_ppsf) }; })}
                  isWeekly={dateOptions.gap}
                  height={270}
                  formatter={function (value) { return "$" + _formatNumber(value); }}
                />
              </div>
              <div className="content">
                {renderEditedOrDefault("priceTrendText", <p id="priceTrendText" className="editable track-original">{AiResponse && AiResponse.price_trend ? AiResponse.price_trend : <CustomSkeleton count={12} />}</p>)}
              </div>
            </div>
          </div>

          <div className="last-part">
            <div>
              {renderEditedOrDefault("daysOnMarketHeading", <h3 id="daysOnMarketHeading" className="editable track-original">Days on Market</h3>)}
              {renderEditedOrDefault("domTrendText", <p id="domTrendText" className="editable track-original">{AiResponse && AiResponse.dom_trend ? AiResponse.dom_trend : <CustomSkeleton count={6} />}</p>)}
              <div>
                <MultipleBarCharts
                  data={(reportData.compResponse.domTrends || []).map(function (item) { return { date: item.val.slice(0, 4), value1: Math.round(item.avg_dom) }; })}
                  height={260}
                  isWeekly={dateOptions.gap}
                  secondValue={false}
                />
              </div>
            </div>

            <div>
              {renderEditedOrDefault("discountHeading", <h3 id="discountHeading" className="editable track-original">Discount</h3>)}
              {renderEditedOrDefault("discountTrendText", <p id="discountTrendText" className="editable track-original">{AiResponse && AiResponse.discount_trend ? AiResponse.discount_trend : <CustomSkeleton count={6} />}</p>)}
              <CustomLineChart
                theme={theme}
                data={(reportData.compResponse.discountTrends || []).map(function (item) { return { date: item.val.slice(0, 4), value: Number.parseFloat(item.avg_discount).toFixed(1) * -1 }; })}
                isWeekly={dateOptions.gap}
                height={260}
                formatter={function (value) { return value + "%"; }}
              />
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default BlendedLayout;

